import {WidgetConfiguration} from '@feature/widget-configs/models/widget-configuration';
import {ITable} from '@common/models/table';
import {Currency} from '@currency/models/currency.model';
import {RuleSet} from 'ngx-angular-query-builder';

export type InvoiceStatusWidgetView =
  'InvoiceStatusTable' |
  'InvoiceStatusVolume' |
  'InvoiceStatusAmount';


export const internal_invoice_status = [
  'Pending',
  'Logged',
  'Approved',
  'Batched',
  'Query',
  'Disapproved',
  'Returned',
  'Cancelled',
  'Part Paid',
  'Paid',
];

export const external_invoice_status = [
  'Pending',
  'Being Processed',
  'Query',
  'Rejected',
  'Cancelled',
  'Part Paid',
  'Paid',
];


const invoiceStatusOrder = [
  'Pending',
  'Being Processed',
  'Logged',
  'Approved',
  'Batched',
  'Query',
  'Disapproved',
  'Returned',
  'Cancelled',
  'Part Paid',
  'Paid',
];


export const invoiceStatusSort = (a, b) => invoiceStatusOrder.indexOf(a.InvoiceStatus) <= invoiceStatusOrder.indexOf(b.InvoiceStatus) ? -1 : 1;

export const mapStatusesToColours = (s: string[]) => s.map(getStatusColor);

export const getStatusColor = (s: string) => s ? statusColourMap[s.toLocaleLowerCase()] : '';

export const statusColourMap = {
  'pending': 'rgb(92, 130, 186)',
  'logged': 'rgb(37, 137, 249)',
  'being processed': 'rgb(37, 137, 249)',
  'approved': 'rgb(0, 255, 255)',
  'batched': 'rgb(37, 137, 249)',
  'query': 'rgb(251, 125, 1)',
  'disapproved': 'rgb(255, 0, 0)',
  'returned': 'rgb(255, 0, 0)',
  'cancelled': 'rgb(118, 113, 113)',
  'part-paid': 'rgb(0, 204, 0)',
  'paid': 'rgb(0, 204, 0)'
}

export function getStatusCssName(status: string) {
  return status.replace(/[^a-z0-9]/g, s => {
    var c = s.charCodeAt(0);
    if (c == 32) return '-';
    if (c >= 65 && c <= 90) return '_' + s.toLowerCase();
    return `__${('000' + c.toString(16)).slice(-4)}`;
  });
}


export const invoiceStatusWidgetViewSelectItems = [
  {
    label: 'Table',
    value: 'InvoiceStatusTable'
  },
  {
    label: 'Status by Volume Chart',
    value: 'InvoiceStatusVolume'
  },
  {
    label: 'Status by Amount Chart',
    value: 'InvoiceStatusAmount'
  }
];

export interface InvoiceStatusWidget {
  id: number;
  currency: Currency;
  currentView: InvoiceStatusWidgetView;
  loading: boolean;
  drillDownActive: boolean;
  drillDownStatus: string;
  drillDownLabel: string;
  data: ITable;
}

export const AllCurrency: Currency = {
  Code: 'ALL',
  Description: 'ALL',
  Symbol: 'ALL',
  DecimalDigits: 0,
};


export const makeRule = (field: string, value: string): RuleSet => {
  if (value == null) return null;
  return {
    condition: 'and',
    rules: [
      {field: field, operator: '=', value: value},
    ]
  }
}

export const makeCurrencyFilter = (currency: Currency) => makeRule('SystemCurrency', currency.Code);
export const makeStatusFilter = (status: string) => makeRule('SystemInvoiceStatus', status);

// placeholder interfaces

// total count of invoices at a given status
export interface InvoiceStatusByVolume {
  InvoiceStatus: string;
  InvoiceCount: number;
}

// total amount of invoices at a given status
export interface InvoiceStatusByAmount {
  InvoiceStatus: string;
  Amount: number;
}


export interface InvoiceStatusConfiguration {
  DefaultView: InvoiceStatusWidgetView;
}

export interface SaveInvoiceStatusWidgetConfigurationRequest {
  widgetConfiguration: WidgetConfiguration;
  invoiceStatusConfig: InvoiceStatusConfiguration;
}
